// extracted by mini-css-extract-plugin
export var list = "BoardMembers-module--list--a805b";
export var listItem = "BoardMembers-module--listItem--73c20";
export var thumbnail = "BoardMembers-module--thumbnail--aafc8";
export var wrapper = "BoardMembers-module--wrapper--3e4fc";